import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiHome = createApi({
  reducerPath: "apiHome",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_PUBLIC_URL}/`,
  }),

  endpoints: (builder) => ({
    // getApiData
    getApiData: builder.query({
      query: (url) => `api/v1/${url}`,
    }),

    getApi: builder.query({
      query: ({ url, lang }) => `${lang}/api/v1/${url}`,
    }),
    getClarification: builder.query({
      query: ({ lang }) => `/api/tenders/${lang}/searchpage3`,
    }),
    getTechno: builder.query({
      query: ({ lang }) => `/api/tenders/${lang}/searchtechno`,
    }),

    getHtmlApi: builder.query({
      query: ({ url, lang }) => `${lang}/node/${url}?_format=json`,
    }),
    getTenderApi: builder.query({
      query: ({ page, title, lang }) =>
        `/api/v1/${lang}/searchpage2?page=${page}&title=${title}`,
    }),
    getArchivedTenderApi: builder.query({
      query: ({ page, title, lang }) =>
        `/api/v1/${lang}/tendersarchive?page=${page}&title=${title}`,
    }),

    // reservoir list  Data
    getWaterLevelData: builder.query({
      query: ({ damInfo, lang }) => `${lang}/api/v1/${damInfo}`,
    }),
    getRainFallLevelData: builder.query({
      query: ({ damInfo, lang }) => `${lang}/api/v1/${damInfo}`,
    }),

    // feedback api
    getFeedbackData: builder.mutation({
      query: ({ url, payload }) => ({
        url,
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getVisitorsCount: builder.query({
      query: (url) => `v1/${url}`,
    }),

    getWaterLevelAPI: builder.query({
      query: ({ date, damId }) =>
        `/api/water-level/search?date=${date}&dm_id=${damId}`,
    }),
    getRainFallAPI: builder.query({
      query: ({ date, damId }) =>
        `/api/rain_fall/search?date=${date}&dm_id=${damId}`,
    }),
    getSearchAPI: builder.query({
      query: ({ query, page, category, fromDate, toDate }) =>
        `/api/global-search?q=${query}&page=${page}&type=${category}&f_date=${fromDate}&to_date=${toDate}`,
    }),
    getCsrGalleryApi: builder.query({
      query: ({ url }) => `/api/v1/${url}`,
    }),
    getStatusOfGeneration: builder.query({
      query: ({ query, lang }) =>
        `/api/v1/${lang}/generation-details?dm=${query}`,
    }),
    getCaptchaImage: builder.query({
      query: () => `/image-captcha-refresh/image_captcha_settings`,
    }),
    getPropertyReturn: builder.query({
      query: ({ name, year }) =>
        `/api/employee?employee_name=${name}&year=${year}`,
    }),
  }),
});

export const {
  useGetWaterLevelDataQuery,
  useGetApiDataQuery,
  useGetApiQuery,
  useGetFeedbackDataMutation,
  useGetHtmlApiQuery,
  useGetVisitorsCountQuery,
  useGetWaterLevelAPIQuery,
  useLazyGetWaterLevelAPIQuery,
  useGetRainFallAPIQuery,
  useGetTenderApiQuery,
  useGetArchivedTenderApiQuery,
  useGetClarificationQuery,
  useGetTechnoQuery,
  useGetSearchAPIQuery,
  useGetCsrGalleryApiQuery,
  useGetStatusOfGenerationQuery,
  useGetCaptchaImageQuery,
  useGetPropertyReturnQuery,
} = apiHome;
